import { FIELDS } from '@/pages/Inventory/constants';

export const shippingFields = [
  {
    cell: 'commands',
    width: 50,
  },
  {
    field: 'onHand',
    cell: 'formatSeparator',
    title: 'On Hand',
    width: 105,
  },
  {
    title: 'Qty To Pull',
    cell: 'qtyToPull',
    width: 105,
  },
  {
    field: 'partNumber',
    title: 'Part',
    width: 200,
  },
  {
    field: 'dateCode',
    title: 'Date Code',
    width: 120,
  },
  {
    field: 'lotCode',
    title: 'Lot Code',
    width: 100,
  },
  {
    field: 'revision',
    title: 'Revision',
    width: 100,
  },
  {
    field: 'conditionName',
    title: 'Condition',
    width: 150,
  },  
  {
    field: 'countryOfOriginName',
    title: 'Country of Origin',
    width: 150,
  },  
  {
    field: 'warehouseName',
    title: 'Warehouse',
    width: 150,
  },
  {
    field: 'location',
    title: 'Location',
    width: 150,
  },
  {
    title: '',
    cell: 'confirm',
    width: 100,
  },
];

export const receivingFields = [
  {
    cell: 'commands',
    width: 50,
  },
  {
    field: 'quantityPulled',
    cell: 'formatSeparator',
    title: 'In Testing',
    width: 105,
  },
  {
    title: 'Received Quantity',
    cell: 'qtyReceived',
    width: 105,
  },
  {
    field: 'partNumber',
    title: 'Part',
    width: 200,
  },
  {
    field: 'dateCode',
    title: 'Date Code',
    width: 120,
  },
  {
    field: 'lotCode',
    title: 'Lot Code',
    width: 100,
  },
  {
    field: 'revision',
    title: 'Revision',
    width: 100,
  },
  {
    field: 'conditionName',
    title: 'Condition',
    width: 150,
  },  
  {
    field: 'countryOfOriginName',
    title: 'Country of Origin',
    width: 150,
  },  
  {
    field: 'warehouseName',
    title: 'Warehouse',
    width: 150,
  },
  {
    field: 'location',
    title: 'Location',
    width: 150,
  },
  {
    title: '',
    cell: 'confirm',
    width: 100,
  },
];
